import { Component } from '@angular/core';

@Component({
  selector: 'rs-accounts-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {}
